import React, { useState } from 'react'
import "./style.css"
import { homePageAssets } from '../../../../assets/media'



const CustomTestimonialsComponent = () => {

    const {
        diamond0,
        diamond1,
        diamond2,
        diamond3,
        diamond4
    } = homePageAssets.customTestimonialAssets


    const testimonials = [
        {
            avatar: diamond0,
            testimonialKey: 0,
            name: "Jamal Nasir",
            designation: "Chief Human Resources Officer",
            companyName: "HBL",
            testimonial: "Together with The Talent Games, we have launched our Cash Officer and Relationship Manager Programs. Both these programs were gamified and customised according to our organisational values. Every year we launch our Internship and Management Trainee Programs with The Talent Games. I must say, they have really changed the recruitment game for HBL."
        },
        {
            avatar: diamond1,
            testimonialKey: 1,
            name: "Nadia Kader",
            designation: "Ex Head of HR & Talent Management",
            companyName: "Grameenphone",
            testimonial: "Bulk recruitment with accurate results was our main concern. The Talent Games turned out to be our best choice to tackle that challenge. Their gamified assessment provided deep candidate insights which helped us save plenty of time in making better hiring decisions."
        },
        {
            avatar: diamond2,
            testimonialKey: 2,
            name: "Dhrub Mandal",
            designation: "Ex Regional Talent Manager",
            companyName: "Nestlé AOA",
            testimonial: "Our partnership with The Talent Games for our signature 'Nesternship Virtual Internship Program' has been phenomenal. The gamified assessments by The Talent Games helped us launch the game across the globe to engage the top talent and resulting in outstanding employer branding."
        },
        {
            avatar: diamond3,
            testimonialKey: 3,
            name: "Nhung Dinh Kim",
            designation: "Ex Head of Human Capital",
            companyName: "Masan Group",
            testimonial: "The Talent Games has completely transformed the way we recruit our talent. With their gamified tests, Masan Group managed to stand out from the crowd and position itself as an innovating employer across Vietnam."
        },
        {
            avatar: diamond4,
            testimonialKey: 4,
            name: "Rehan Naeem",
            designation: "Head of Culture, D&I",
            companyName: "Bank Alfalah Limited",
            testimonial: "A remarkable hiring solution for HR professionals. Thanks to The Talent Games, we have been hiring top talent as Interns and Management Trainees for our Bank. Our gamified tests effectively demonstrate our values and culture, giving us great employer branding opportunities."
        },

    ]

    const [currentData, setCurrentData] = useState(testimonials[3])


    const [isTextVisible, setisTextVisible] = useState(true)
    const fetchDiamondDetails = (e) => {

        e.currentTarget.className = `object-contain w-[10rem] opacity-0 cursor-pointer ${isTextVisible && '!opacity-100'} ease-linear duration-500 delay-150`
        setisTextVisible(false)
        const index = parseInt(e.target.alt)

        e.target.src = currentData.avatar
        e.target.alt = currentData.testimonialKey
        setTimeout(() => {
            setCurrentData(testimonials[index])

            setisTextVisible(true)

        }, 450);
    }


    return (
        <div className="CustomTestimonialsComponent hidden sm:flex sm:w-[35rem] md:w-full lg:w-[50rem] xl:w-[60rem] 2xl:w-[70rem]  mx-auto  justify-center bg-background bg-contain bg-center bg-no-repeat py-5">
            <div className="col leftCol sm:w-[12rem] lg:w-[20rem] flex flex-row-reverse justify-end">
                <div className="left  flex sm:items-center lg:items-end justify-start h-[50%]">

                    <div className="imgCover p-1  bg-center sm:bg-[length:2.7rem_2.7rem] md:bg-[length:4.7rem_4.7rem] lg:bg-[length:4.5rem_4.5rem] 2xl:bg-[length:6.5rem_6.5rem] xl:bg-[length:6.2rem_6.2rem] transition-all hover:bg-diamondBack hover:scale-[1.05] ease-in-out">
                        <img onClick={fetchDiamondDetails} src={diamond0} className="object-contain w-[10rem] cursor-pointer" alt="0" />
                    </div>
                </div>
                <div className="right  flex items-end justify-end h-[80%]">
                    <div className="imgCover p-1  bg-center sm:bg-[length:3.2rem_3.2rem] md:bg-[length:4.6rem_4.6rem] lg:bg-[length:5.5rem_5.5rem] 2xl:bg-[length:6.5rem_6.5rem] xl:bg-[length:6.2rem_6.2rem] transition-all hover:bg-diamondBack hover:scale-[1.05] ease-in-out">
                        <img onClick={fetchDiamondDetails} src={diamond1} className="w-[10rem] sm:w-[10rem] object-contain cursor-pointer" alt="1" />
                    </div>

                </div>
            </div>

            <div className="col centerCol sm:w-[50rem]  lg:w-[70rem] p-1 2xl:w-[80rem]">


                {/* chat bubble new */}
                <div className="chatBubble  rounded-lg m-20 p-10 lg:h-[12rem] lg:px-10 shadow-chatBubble flex justify-center items-center">
                    <div className={`opacity-0 testimonialParagraph  text-[10px] font-semibold leading-[20px] text-center  2xl:text-[16px] 2xl:leading-[25px] transition-opacity ${isTextVisible && '!opacity-100'} ease-linear duration-500 delay-150 `}>
                        {currentData.testimonial}
                    </div>
                </div>

                <div className="diamondAvatarAndInfoContainer w-[60%] mx-auto ">

                    <div className={` opacity-0 diamondAvatarWithInfo flex items-center transition-opacity duration-500 delay-150 ${isTextVisible && '!opacity-100'}`}>
                        <div className="imgCover p-1 bg-diamondBack bg-center sm:bg-[length:5.3rem_5.3rem] md:bg-[length:5.3rem_5.3rem] lg:bg-[length:5.3rem_5.3rem] xl:bg-[length:6.3rem_6.3rem]">
                            <img src={currentData.avatar} className="object-contain   sm:w-[4rem] lg:w-[5rem]" alt="" />
                        </div>
                        <div className="info ml-5">
                            <div className="name sm:text-[16px] sm:leading-[20px] lg:text-[24px] lg:leading-[30px] font-bold text-[#3F4941]">{currentData.name}</div>
                            <div className="designation text-[#7F837F] sm:text-[12px] sm:leading-[16px] lg:text-[16px] font-bold lg:leading-[20px]">{currentData.designation}</div>
                            <div className="companyName text-[#FEBB12] sm:text-[12px] sm:leading-[16px] lg:text-[16px] lg:leading-[20px] font-bold">{currentData.companyName}</div>
                        </div>
                    </div>
                </div>


            </div>

            <div className="col rightCol sm:w-[13rem]  lg:w-[20rem] flex">
                <div className="left w-[50%] flex flex-col items-center justify-start pt-20 h-full">

                    <div className="imgCover p-1  bg-center  sm:bg-[length:3.2rem_3.2rem] md:bg-[length:5rem_5rem] lg:bg-[length:5rem_5rem] 2xl:bg-[length:6.5rem_6.5rem] xl:bg-[length:6.2rem_6.2rem] transition-all hover:bg-diamondBack hover:scale-[1.05] ease-in-out">
                        <img onClick={fetchDiamondDetails} className="cursor-pointer" src={diamond2} alt="2" />
                    </div>


                </div>
                <div className="left w-[50%] flex items-end justify-end h-[64%]">
                    <div className="imgCover p-1  bg-center  sm:bg-[length:3.2rem_3.2rem] md:bg-[length:5rem_5rem] lg:bg-[length:5rem_5rem] 2xl:bg-[length:6.5rem_6.5rem] xl:bg-[length:6.2rem_6.2rem] transition-all hover:bg-diamondBack hover:scale-[1.05] ease-in-out">
                        <img onClick={fetchDiamondDetails} className="cursor-pointer" src={diamond4} alt="4" />
                    </div>

                </div>
            </div>
        </div>

    )
}

export default CustomTestimonialsComponent